import { render, staticRenderFns } from "./test8-1.vue?vue&type=template&id=7412d265&scoped=true"
import script from "./test8-1.vue?vue&type=script&lang=js"
export * from "./test8-1.vue?vue&type=script&lang=js"
import style0 from "./test8-1.vue?vue&type=style&index=0&id=7412d265&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7412d265",
  null
  
)

export default component.exports